// extracted by mini-css-extract-plugin
export var container = "post-module--container--n42Ry";
export var innerContainer = "post-module--innerContainer--1FyWM";
export var postImage = "post-module--postImage--8lZU0";
export var hero = "post-module--hero--2dhiD";
export var heroText = "post-module--heroText--19yVH";
export var content = "post-module--content--2sKqa";
export var title = "post-module--title--4X1pO";